<template>
    <div>
        <el-card
            class="box-card"
            style="width: 26rem; height: 100%"
            v-drag="{ handle: '#someElement' }"
        >
            <div slot="header" id="someElement">
                <span style="font-weight: 600">{{ locationPopInfo.name }}</span>
            </div>
            <div style="text-align: left">
                <el-row style="margin-top: 0.6rem; margin-right: 1.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong>聚落简介：</strong>
                    </el-col>
                    <el-col :span="14">
                        <span>{{
                            locationPopInfo.excursus == null
                                ? '暂无介绍'
                                : locationPopInfo.excursus
                        }}</span></el-col
                    >
                </el-row>
                <el-row style="margin-top: 0.6rem; margin-right: 1.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong style="line-height: 2rem">坐标：</strong>
                    </el-col>
                    <el-col :span="18">
                        <span>
                            <el-input
                                type="text"
                                style="width: 100%"
                                placeholder="请输入内容"
                                v-model="lonlat[0]"
                            >
                            </el-input>
                            <el-input
                                type="text"
                                style="width: 100%"
                                placeholder="请输入内容"
                                v-model="lonlat[1]"
                            >
                            </el-input>
                        </span>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 0.6rem; margin-right: 1.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong style="line-height: 2rem">今地名：</strong>
                    </el-col>
                    <el-col :span="18">
                        <span>
                            <el-input
                                type="textarea"
                                style="width: 100%"
                                :rows="2"
                                placeholder="请输入内容"
                                v-model="n_position"
                            >
                            </el-input>
                        </span>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 0.6rem; margin-right: 1.6rem">
                    <el-col :span="6" style="text-align: right">
                        <strong style="line-height: 2rem">定位理由：</strong>
                    </el-col>
                    <el-col :span="18">
                        <span>
                            <el-input
                                type="textarea"
                                style="width: 100%"
                                :rows="2"
                                placeholder="请输入内容"
                                v-model="reason_position"
                            >
                            </el-input>
                        </span>
                    </el-col>
                </el-row>
                <el-row
                    style="
                        margin-top: 0.6rem;
                        margin-left: 1.8rem;
                        margin-right: 1.8rem;
                        margin-bottom: 0.6rem;
                        text-align: right;
                    "
                >
                    <el-col :span="8">
                        <el-button @click="saveNewLocation()" type="primary"
                            >保存地点</el-button
                        >
                    </el-col>
                    <el-col :span="8">
                        <el-button @click="retryNewLocation()" type="primary"
                            >重新定位</el-button
                        >
                    </el-col>
                    <el-col :span="8">
                        <el-button @click="closeNewLocation()"
                            >&nbsp;&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;&nbsp;</el-button
                        >
                    </el-col>
                </el-row>
            </div>
        </el-card>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    data() {
        return {
            n_position: '',
            reason_position: '',
        }
    },
    watch: {
        lonlat(newValue) {
            this.getAddress(newValue)
            this.reason_position = ''
            this.$emit('lonlatChange', newValue)
        },
    },
    props: {
        locationPopInfo: Object,
        lonlat: Array,
    },
    mounted() {},
    computed: {},
    methods: {
        getAddress(lonlat) {
            if (lonlat.length == 0) return ''
            let key = '719db4cca683b30963c21ef4211504ec'
            let self = this
            axios
                .get(
                    ' https://api.tianditu.gov.cn/geocoder?postStr={%27lon%27:' +
                        lonlat[0] +
                        ',%27lat%27:' +
                        lonlat[1] +
                        ',%27ver%27:1}&type=geocode&tk=' +
                        key
                )
                .then((res) => {
                    self.n_position = res.data.result.formatted_address
                })
        },
        saveNewLocation() {
            this.$emit('saveAddNewLocation', {
                data: this.locationPopInfo,
                n_position: this.n_position,
                reason_position: this.reason_position,
                lonlat: this.lonlat,
            })
        },
        retryNewLocation() {
            this.$emit('retryAddNewLocation')
        },
        closeNewLocation() {
            this.$emit('cancleAddNewLocation')
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/V3/Main/Home/comAddNewLocationPop.vue